import React, { useMemo } from "react";
import upload from "../../../Assets/newUpload.svg";
import style from "./index.module.css";
import plus from "../../../Assets/newPlus.svg";

const RecSecondForm = ({ changeImage, formData }) => {
  const preview = useMemo(() => {
    return formData?.profilePhoto && typeof formData?.profilePhoto !== "string"
      ? URL.createObjectURL(formData?.profilePhoto)
      : null;
  }, [formData.profilePhoto]);

  return (
    <div className={style.maincont}>
      {/* profile pic */}
      <div className={style.uploadphoto}>
        {preview === null ? (
          <img
            style={{ height: "100px", width: "100px", marginTop: "-1rem" }}
            src={plus}
            alt=""
          />
        ) : (
          <img src={preview} alt="" />
        )}
      </div>
      <label
        htmlFor="file"
        style={{
          fontFamily: "Roboto",
          fontSize: "18px",
          letterSpacing: "0.04em",
          fontWeight: "500",
        }}
        className={style.uploadBtn}
      >
        <img src={upload} alt="" />
        <input
          id="file"
          type="file"
          placeholder="Profile Photo"
          name="file"
          onChange={changeImage}
          hidden
          autoComplete="off"
        />
        Upload
      </label>
    </div>
  );
};

export default RecSecondForm;
